export default __webpack_public_path__ + "static/media/hm-sg-img.39e98215.webp";